<template>
  <div class="company-introduce-background">
    <div class="company-introduce-banner">
      <div class="company-introduce-container">
        <div class="company-introduce-banner-title">{{ $t("about.title") }}</div>
      </div>

      <img class="company-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="company-introduce-container">

     <div class="company-introduce-content">
       <div class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">{{ $t("about.company") }}</div>
       </div>
       <div class="company-introduce-content-info">
         <p class="company-introduce-content-info-text">{{ $t("about.companyp") }}</p>
         <!-- <p class="company-introduce-content-info-text">{{ $t("about.companyp1") }}</p> -->
         <!-- <p class="company-introduce-content-info-text">{{ $t("about.companyp2") }}</p> -->
       </div>

       <div class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">{{ $t("about.team") }}</div>
       </div>
       <div class="company-introduce-content-info">
        <p class="company-introduce-content-info-text">{{ $t("about.teamp") }}</p>
       </div>
       <div class="company-introduce-content-info">
         <p class="company-introduce-content-info-title-text">{{ $t("about.teamt1") }}</p>
         <p class="company-introduce-content-info-text">{{ $t("about.teamp1") }}</p>
         <p class="company-introduce-content-info-title-text">{{ $t("about.teamt2") }}</p>
         <p class="company-introduce-content-info-text">{{ $t("about.teamp2") }}</p>
       </div>
       <div class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">{{ $t("about.investor") }}</div>
       </div>
       <div class="company-introduce-content-investor">
         <img class="company-introduce-content-investor-img" src="../../assets/about/investor.png" alt="investor">
       </div>

       <div id="customers" class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">{{ $t("cooperate.title") }}</div>
       </div>
       <div class="company-introduce-content-info">
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR1C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR1C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR1C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR2C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR2C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR2C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR3C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR3C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR3C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR4C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR4C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR4C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR5C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR5C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR5C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR6C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR6C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR6C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR7C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR7C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR7C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR8C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR8C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR8C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR9C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR9C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR9C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR10C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR10C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR10C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR11C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR11C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR11C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR12C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR12C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR12C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR13C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR13C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR13C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR14C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR14C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR14C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR15C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR15C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR15C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR16C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR16C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR16C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR17C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR17C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR17C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR18C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR18C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR18C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR19C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR19C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR19C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR20C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR20C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR20C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR21C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR21C2") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR21C3") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR22C1") }}</p>
         <p class="company-introduce-content-info-text company-introduce-content-university"><i class="fa fa-university company-introduce-content-university-fa"></i>{{ $t("cooperate.cooperateR22C2") }}</p>
       </div>

       <div id="contact" class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">{{ $t("contract.contractDetails") }}</div>
       </div>

       <baidu-map
         class="company-introduce-map"
         :center="{ lng: 116.360203, lat: 40.021519 }"
         :zoom="17"
       >
         <bm-marker
           :position="{ lng: 116.360203, lat: 40.021519 }"
           :dragging="true"
           @click="infoWindowOpen"
         >
           <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
           <bm-info-window
             :show="show"
             @close="infoWindowClose"
             @open="infoWindowOpen"
           >
             <p style="margin-bottom: 2px">
               {{ $t("contract.addressText") }}
             </p>
             <p style="margin-bottom: 2px">电话：400-618-6006</p>
           </bm-info-window>
         </bm-marker>
       </baidu-map>

       <div class="company-introduce-content-info company-introduce-content-info-phone">
         <p class="company-introduce-content-info-text">
           <a class="company-introduce-content-info-phone-text">{{ $t("contract.salePhone") }}</a>400-618-6006
         </p>
         <p class="company-introduce-content-info-text">
           <a class="company-introduce-content-info-phone-text">{{ $t("contract.supportPhone") }}</a>400-618-6006
         </p>
         <p class="company-introduce-content-info-text">
           <a class="company-introduce-content-info-phone-text">{{ $t("contract.mail") }}</a>support@pwmat.com
         </p>
         <p class="company-introduce-content-info-text">
           <a class="company-introduce-content-info-phone-text">{{ $t("contract.wechat") }}</a>{{ $t("contract.wechatText") }}
         </p>
         <p class="company-introduce-content-info-text">
           <a class="company-introduce-content-info-phone-text">{{ $t("contract.address") }}</a>{{ $t("contract.addressText") }}
         </p>
       </div>

       <!-- <div class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">{{ $t("about.solution") }}</div>
       </div>
       <div class="company-introduce-content-info">
         <p class="company-introduce-content-info-title-text"><i class="fa fa-hand-o-right company-introduce-content-info-title-fa"></i>{{ $t("about.solutionp1") }}</p>
         <p class="company-introduce-content-info-text">{{ $t("about.solutionp2") }}</p>
         <p class="company-introduce-content-info-title-text"><i class="fa fa-hand-o-right company-introduce-content-info-title-fa"></i>{{ $t("about.solutionp3") }}</p>
         <p class="company-introduce-content-info-text">{{ $t("about.solutionp4") }}</p>
         <p class="company-introduce-content-info-title-text"><i class="fa fa-hand-o-right company-introduce-content-info-title-fa"></i>{{ $t("about.solutionp5") }}</p>
         <p class="company-introduce-content-info-text">{{ $t("about.solutionp6") }}</p>
       </div> -->

     </div>
    </div>
  </div>
</template>

<script>
  import BaiduMap from "vue-baidu-map/components/map/Map.vue";

  export default {
    name: "companyIntroduce",
    components: {
      BaiduMap,
    },
    data() {
      return {
        show: true,
      }
    },
    mounted() {
      this.scrollToHash()
    },
    watch: {
      '$route.hash'() {
        this.scrollToHash()
      }
    },
    methods: {
      infoWindowClose() {
        this.show = false
      },
      infoWindowOpen() {
        this.show = true
      },
      scrollToHash() {
        const hash = this.$route.hash
        if (hash === '#customers' || hash === '#contact') {
          this.$nextTick(() => {
            const el = document.getElementById(hash.slice(1))
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .company-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .company-introduce-background{
    margin-top: 70px;
    overflow-x: hidden;
  }
  .company-introduce-banner{
    overflow:hidden;
  }
  .company-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .company-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .company-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .company-introduce-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .company-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .company-introduce-content-info{
    margin-top: 50px;
  }
  .company-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .company-introduce-content-info-title-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight: bolder;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .company-introduce-content-info-title-fa{
    font-size: 22px;
    padding-right: 8px;
  }
  .company-introduce-content-investor{
    margin-top: 50px;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }
  .company-introduce-content-investor-img{
    display: block;
    flex: 1 1 0;
    min-width: 0;
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  .company-introduce-content-university{
    width: 346px;
    display: inline-block;
  }
  .company-introduce-content-university-fa{
    font-size: 14px;
    padding-right: 8px;
  }
  .company-introduce-map {
    margin-top: 50px;
    width: 550px;
    height: 350px;
    display: inline-block;
    vertical-align: top;
    border: 4px solid gainsboro;
  }
  .company-introduce-content-info-phone {
    width: 438px;
    display: inline-block;
    vertical-align: top;
    padding-left: 60px;
  }
  .company-introduce-content-info-phone-text {
    font-size: 16px;
    font-family: PingFangSC-Regular, sans-serif;
    font-weight: bolder;
    color: rgba(79, 76, 77, 1);
    line-height: 25px;
  }

  @media screen and (max-width:482px) {
    .company-introduce-container{
      max-width: 100%;
    }
    .company-introduce-map {
      width: 100%;
      height: 286px;
      display: block;
    }
    .company-introduce-content-info-phone {
      width: unset;
      display: block;
      padding-left: 0;
      margin-top: 50px;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .company-introduce-container{
      max-width: 450px;
    }
    .company-introduce-map {
      width: 450px;
      height: 286px;
      display: block;
    }
    .company-introduce-content-info-phone {
      width: unset;
      display: block;
      padding-left: 0;
      margin-top: 50px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .company-introduce-container{
      max-width: 736px;
    }
    .company-introduce-map {
      width: 736px;
      height: 468px;
      display: block;
    }
    .company-introduce-content-info-phone {
      width: 438px;
      display: block;
      padding-left: 0;
      margin-top: 50px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .company-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .company-introduce-container{
      max-width: 1068px;
    }
  }

</style>
